import { call, put } from "redux-saga/effects";
import { MLAPI } from "api";
import * as Actions from "UserAuthorized/actionTypes";
import Enum from "contracts/responses/Enum";
import _ from "lodash";

export function* getActions() {
  const { response, error } = yield call(MLAPI.enum.getActions);
  if (response) {
    yield put({
      type: Actions.ENUM_GET_ACTIONS_SUCCESSFUL,
      payload: _.map(response.data.data, function(n) {
        return new Enum(n);
      })
    });
  } else
    yield put({
      type: Actions.ENUM_GET_VERBS_ERROR,
      payload: error
    });
}
